import { Doughnut, mixins } from 'vue-chartjs'
const { reactiveProp }  = mixins
export default{
    props:['chartdata','options'],
    extends: Doughnut,
    watch: {
        chartdata(){
            this.renderChart(this.chartdata, this.options)
        }
    }
}